<template>
    <div class="our-partner-container">
        <div
            v-for="(partner, index) in partners"
            :key="'partner-' + index"
            class="our-partner-item"
        >
            <img :src="partner.image" :alt="partner.title + ' our partners'" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            partners: [
                {
                    title: "QCP Capital",
                    image: "/images/our-partners/qcp-small-logo-2-dark.svg",
                    url: "https://qcp.capital/"
                },
                {
                    title: "Tron",
                    image: "/images/our-partners/tron-logo-white.svg",
                    url: "https://tron.network/"
                },
                {
                    title: "Terra",
                    image: "/images/our-partners/terra-logo-dark.svg",
                    url: "https://www.terra.money/"
                },
                {
                    title: "Oasis Foundation",
                    image: "/images/our-partners/oasis-logo-white.svg",
                    url: "https://oasisprotocol.org/"
                },
                {
                    title: "Fantom",
                    image: "/images/our-partners/fantom-logo-white.svg",
                    url: "https://fantom.foundation/"
                },
                {
                    title: "Algorand",
                    image: "/images/our-partners/algorand-logo-white.svg",
                    url: "https://www.algorand.com/"
                },
                {
                    title: "Polygon",
                    image: "/images/our-partners/polygon-logo-white.svg",
                    url: "https://polygon.technology/"
                },
                {
                    title: "DeFi Capital",
                    image: "/images/our-partners/defi-capital-logo.png",
                    url: "https://deficapital.com/"
                },
                {
                    title: "Avalanche",
                    image: "/images/our-partners/avax-logo.svg",
                    url: "https://www.avax.network/"
                },
               {
                    title: "Boba",
                    image: "/images/our-partners/boba-logo.svg",
                    url: "https://boba.network/"
                },
               {
                    title: "Binance",
                    image: "/images/our-partners/bsc-logo.svg",
                    url: "https://binance.com/"
                },
               {
                    title: "AURORA",
                    image: "/images/our-partners/aurora-logo.svg",
                    url: "https://www.aurorachain.io/"
                },
               {
                    title: "CRO",
                    image: "/images/our-partners/cro-logo.png",
                    url: "https://crypto.com/"
                },
            ]
        };
    }
};
</script>

<style lang="scss">
.our-partner-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .our-partner-item {
        flex: 0 0 auto;
        /* width: 33.3333333333334%; */
        width: 50%;
        height: 70px;
        padding: 10px 20px;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;

        @media only screen and (min-width: 768px) {
            width: 25%;
        }

        @media only screen and (min-width: 1440px) {
            height: 4.861111111111111vw;
            padding: 0.6944444444444444vw 1.3888888888888888vw;
            margin-bottom: 2.0833333333333335vw;
        }

        img {
            position: relative;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
}
</style>
